import React, { FunctionComponent } from 'react';
import type { Special } from '../../../types/toppage';

type Props = {
  specials: Special[];
};

export const Presentation: FunctionComponent<Props> = ({ specials }) => {
  return (
    <section className="sitetop-recruitment" id="from_specials">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          SPECIALS<span className="sitetop-pickup-sub">特集</span>
        </h2>
        <a
          href="/specials"
          className="sitetop-pickup-companies"
          data-event="click"
          data-category="topcontent"
          data-value="from_specials"
        >
          特集一覧へ
        </a>
      </div>
      <div className="sitetop-recruitment-container js-sitetop-recruitment-slick">
        {specials.map((special) => (
          <a
            key={special.id}
            href={'/specials/' + special.id}
            className="sitetop-recruitment-container-link"
            data-event="click"
            data-category="topcontent"
            data-value="from_specials"
          >
            <div className="sitetop-recruitment-container-box">
              <div className="sitetop-recruitment-container-box-inner">
                <div
                  style={{
                    background: 'url(' + special.cover_image.url + ') no-repeat center center',
                    backgroundSize: 'cover',
                  }}
                  className="sitetop-recruitment-container-box-inner-img-bg"
                ></div>
                <div className="sitetop-recruitment-container-box-inner-mag">
                  <div className="sitetop-recruitment-container-box-title">{special.title}</div>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
      <a
        href="/specials"
        className="sitetop-pickup-spcompanies"
        data-event="click"
        data-category="topcontent"
        data-value="from_specials"
      >
        特集一覧へ
      </a>
    </section>
  );
};
